import React from "react";
import "../resumo-boleto/Style.css";
import ResumoBoleto from "../../../components/acesso-rapido/boleto/resumo-boleto/index";

export default function () {
  return <ResumoBoleto />;
}
